'use client';

import { reader } from '@woonstad/helpers-utils';
import { useEffect, useRef, useState } from 'react';

export interface ImagePreviewProps {
  file: File;
  error?: boolean;
  onError?: (error: Error) => void;
  className?: string;
}

export function ImagePreview(props: ImagePreviewProps) {
  const imageRef = useRef<HTMLImageElement>(null);
  const [loadingError, setLoadingError] = useState<boolean>(props.error ?? false);
  const hasError = props.error || loadingError;

  useEffect(() => {
    async function renderImage(file: File) {
      try {
        const base64File = await reader(file);

        if (imageRef.current) {
          imageRef.current.src = base64File;
        }
      } catch (e) {
        console.error(e);

        setLoadingError(true);
      }
    }

    renderImage(props.file);
  }, [props.file, hasError]);

  return (
    <img
      ref={imageRef}
      alt={`Preview van ${props.file.name}`}
      className={props.className}
    />
  );
}
